import {
  IcoBuilding16,
  IcoChart16,
  IcoCheckCircle16,
  IcoChecklist16,
  IcoFileSearch16,
  IcoFileText16,
  IcoFlag16,
  IcoLaptop16,
  type Icon,
  IcoUserCircle16,
  IcoUserDuplicate16,
} from '@onefootprint/icons';
import type { SectionKey } from '../../onboardings.types';

const SECTION_ICONS: Record<SectionKey, Icon> = {
  'user-data': IcoUserCircle16,
  'business-data': IcoBuilding16,
  documents: IcoFileText16,
  rules: IcoChecklist16,
  'risk-signals': IcoFlag16,
  'field-validations': IcoCheckCircle16,
  'duplicate-data': IcoUserDuplicate16,
  'business-insights': IcoFileSearch16,
  'device-insights': IcoLaptop16,
  'other-insights': IcoChart16,
};

export default SECTION_ICONS;
